import { getCookie } from 'cookies-next/client'
import type { IRedux } from '../_store/types'

export const DEFAULT_ORDER_SOURCE_ID = '3429e492-5faa-4e17-a19e-b32a4d01b267'

export function resolveSourceId(
  session: IRedux['session'],
  auth: IRedux['auth']
): string | undefined {
  return (
    session?.source_id ??
    auth?.miniAppCrmData?.source_id ??
    (getCookie('source_id') as string | undefined)
  )
}

/** Same source id chain as home menu `aggregator_id` (category / product list). */
export function resolveOrderSourceId(
  session: IRedux['session'],
  auth: IRedux['auth']
): string {
  return resolveSourceId(session, auth) || DEFAULT_ORDER_SOURCE_ID
}

/** Home passes `platform_id` from session (set to source_id in mini app init). */
export function resolvePlatformId(
  session: IRedux['session'],
  sourceId?: string
): string {
  return session?.platform_id || sourceId || ''
}

/** Selected payment type, falling back to the CRM credentials payment type. */
export function resolvePaymentTypeId(
  checkout: IRedux['checkout'],
  auth: IRedux['auth']
): string | undefined {
  return checkout?.payment_type?.id || auth?.miniAppCrmData?.payment_type_id
}
